import React from 'react'
import { withLocalize, Translate } from "react-localize-redux";
import ResponsiveTable from '../../layoutItems/responsiveTable';
import UnderlinedTitle from "../../common/underlinedTitle";
import { isNullOrUndefined } from '../../../store/storeFunctions';
import BbCheckbox from '../../styling/bbFormikCheckbox';
import BbInput from '../../styling/bbInput';
import { hasPermission } from '../../../store/apiWrapper';
import { Formik, Form } from 'formik';
import classnames from 'classnames';
import PropTypes from 'prop-types'

import './aml.scss';

class AmlRequestForm extends React.Component {
    static propTypes = {
        data: PropTypes.any,
        asReport: PropTypes.bool,
        asPopup: PropTypes.bool,
        setAmlTreeValue: PropTypes.func,
        onClick: PropTypes.func,
    };

    static defaultProps = {
        asReport: false,
        asPopup: false
    };

    state = {
        amlTree: true
    }

    submitForm = (amlTree) => {
        if (this.props.asReport) {
            this.props.setAmlTreeValue(amlTree);
        }
        this.props.onClick();
    }

    render() {
        const data = this.props.data;
        const amount = !isNullOrUndefined(data.amount) ? data.amount : 4;
        if (data === undefined || data === null)
            return null;

        return (
            <React.Fragment>
                <Formik
                    ref={(el) => this.formRef = el}
                    enableReinitialize
                    initialValues={{
                        amlTree: true
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        setSubmitting(false); // 'loading' status is handled by Redux so immediately reset Formik's 'submitting' flag
                        this.submitForm(values.amlTree);
                    }}>
                    {({ values, setFieldValue }) => (
                        <Form>
                            <div style={{ marginBottom: "2em", marginTop: this.props.asPopup ? "0.5em" : "0" }}>
                                <UnderlinedTitle header={this.props.translate("Report.Aml.Request.Title")} />
                            </div>
                            <ResponsiveTable>
                                <table className="table table-report-section">
                                    <tbody>
                                        <tr className="colorize">
                                            <td className="bold"><Translate id="Report.Aml.Request.Summary.Company" />:</td>
                                            <td>{data.companyName}</td>
                                        </tr>
                                        <tr className="colorize">
                                            <td className="bold"><Translate id="Report.Aml.Request.Summary.CheckedSubjects" />:</td>
                                            <td>
                                                <ul>
                                                    <li><Translate id="Report.Aml.Request.Summary.StatutoryBody" /></li>
                                                    <li><Translate id="Report.Aml.Request.Summary.Owners" /></li>
                                                    <li><Translate id="Report.Aml.Request.Summary.FinalBenefitsUsers" /></li>
                                                    {data.amlRelationProfiles.includes("B") && <li><Translate id="Report.Aml.Subjects.SupervisoryBoard" /></li>}
                                                    {data.amlRelationProfiles.includes("P") && <li><Translate id="Report.Aml.Subjects.PublicFunctions" /></li>}

                                                </ul>
                                            </td>
                                        </tr>
                                        <tr className="colorize">
                                            <td className="bold"><Translate id="Report.Aml.Request.Summary.Methodology" />:</td>
                                            <td>
                                                {this.translateMethodology(data.methodology)}
                                                {data.methodology === "cos" ? this.props.translate("Report.Aml.Request.Share", { share: data.share }) : ""}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </ResponsiveTable>
                            <div className="aml-warning-info">
                                {this.props.asReport && <div>
                                    <div >
                                        {hasPermission(null, "AMLPathToBeneficialUser") && <BbInput type='custom' label={this.props.translate('Search.Aml.AmlTree.Label')}
                                            style={{ display: 'inline-flex' }}
                                            custom={
                                                <BbCheckbox
                                                    value={values.amlTree}
                                                    id={'amlTree'}
                                                    name={'amlTree'}
                                                    onChange={c => setFieldValue('amlTree', c)}
                                                    style={{ marginLeft: '2em', display: 'block' }}
                                                />
                                            }
                                        />}
                                    </div>
                                </div>}
                                <div>
                                    <Translate id="Report.Aml.Request.PercentOfConfidenceDisclaimer" data={{ minConfidence: 95 }} options={{ renderInnerHtml: true }} />
                                </div>
                                {this.props.asReport && <div>
                                    <Translate id="Report.Aml.Request.ChargeWarningReport" data={{ units: amount }} options={{ renderInnerHtml: true }} />
                                </div>}
                                {!this.props.asReport && <div>
                                    <Translate id="Report.Aml.Request.ChargeWarning" data={{ units: amount }} options={{ renderInnerHtml: true }} />
                                </div>}
                            </div>
                            {!this.props.asPopup && <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <button type="submit" className={classnames('bb-button gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}>
                                    <Translate id="Report.Aml.Request.Submit" />
                                </button>
                            </div>}
                        </Form>
                    )}
                </Formik>
            </React.Fragment>
        );
    }

    translateMethodology = (methodology) => {
        switch (methodology) {
            case "cos": return this.props.translate("Report.Aml.Request.CosMethodology");
            case "dos": return this.props.translate("Report.Aml.Request.DosMethodology");
            default: return null;
        }
    }
}

export default withLocalize(AmlRequestForm);

